import Avatar from 'react-avatar';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useState} from "react";
import Badge from "../../components/Badge";
import {DateTimeOptionsMediumShort} from "../../utils/DateTimeOptions";
import CopyToClipBoard from "../../components/CopyToClipBoard";
import NoneValue from "../../components/NoneValue";

function Invoice({invoice}) {
    const invoiceUrl = invoice.invoice_url || null;
    const invoiceHref = invoiceUrl && /^https?:\/\//i.test(invoiceUrl) ? invoiceUrl : invoiceUrl ? `https://${invoiceUrl}` : null;
    const shortInvoiceUrl = invoice.short_invoice_url || null;
    const shortInvoiceHref = shortInvoiceUrl && /^https?:\/\//i.test(shortInvoiceUrl) ? shortInvoiceUrl : shortInvoiceUrl ? `https://${shortInvoiceUrl}` : null;

    const renderCopyableLink = (url, href) => {
        if (!url) return <NoneValue />;

        return (
            <CopyToClipBoard link={href}>
                <a href={href} target="_blank" rel="noopener noreferrer">{url}</a>
            </CopyToClipBoard>
        );
    };

    const [invoiceDetailsModal, setInvoiceDetailsModal] = useState(false);
    const invoiceDetailsModalToggle = () => {
        setInvoiceDetailsModal(!invoiceDetailsModal);
    };
    const [expandedProducts, setExpandedProducts] = useState(false);
    const toggleExpansion = () => {
        setExpandedProducts(!expandedProducts);
    };

    const invoiceStatusBadgeMap = {
        PAID: "badge badge-light-success",
        UNPAID: "badge badge-light-warning",
        CANCELLED: "badge badge-light-danger",
        "WAIVED-OFF": "badge badge-light-info",
        CREDITED: "badge badge-light-secondary",
    };

    return (
        <>
            <tr>
                <td className="invoice-pointer text-primary" onClick={invoiceDetailsModalToggle}>{invoice.invoice_number || invoice.id}</td>
                <td>{invoice.customer_email || '-'}</td>
                <td>
                    {renderCopyableLink(shortInvoiceUrl || invoiceUrl, shortInvoiceHref || invoiceHref)}
                </td>
                <td style={{ display: 'flex', alignItems: 'center', gap: "4px" }}>
                    {invoice.order.order_items.slice(0, 3).map((item) => (
                        <div key={item.id} title={item.name}>
                            {item?.product_add_on_item?.product_image || item?.product_group_add_on_item?.product_group_image ? (
                                <img
                                    src={
                                        item?.product_add_on_item?.product_image ||
                                        item?.product_group_add_on_item?.product_group_image
                                    }
                                    className="avatar-sm img-thumbnail rounded-circle"
                                    alt={item.name}
                                />
                            ) : (
                                <Avatar size={35} name={item?.name} round />
                            )}
                        </div>
                    ))}
                    <span className="badge badge-light-primary">{invoice.order.order_items.length} items</span>
                    {invoice.order.order_items.length > 3 ? (
                        <span onClick={() => {
                            invoiceDetailsModalToggle()
                            toggleExpansion()
                        }} style={{ cursor: 'pointer' }}>
                            <div
                                style={{
                                    width: '35px',
                                    height: '35px',
                                    backgroundColor: 'grey',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    color: 'white',
                                    fontSize: '12px',
                                }}
                                title={invoice.order.order_items.slice(3).map(item => item.name).join(', ')}
                            >
                                {`+${invoice.order.order_items.length - 3}`}
                            </div>
                        </span>
                    ) : null}
                </td>
                <td>
                    {invoice.total_tax}
                </td>
                <td>
                    {invoice.total_amount}
                </td>
                {/*<td>*/}
                {/*    <Badge badge={*/}
                {/*        invoice.status === "PAID"*/}
                {/*            ? "badge badge-light-success"*/}
                {/*            : "badge badge-light-danger"*/}
                {/*    } status={invoice.status === true? "Yes": "No"}/>*/}
                {/*</td>*/}
                <td>
                    <Badge
                        badge={invoiceStatusBadgeMap[invoice.status] || "badge badge-light-secondary"}
                        status={invoice.status}
                    />
                </td>
                <td>{new Date(invoice.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
            </tr>

            <Modal className={'modal-xl'} isOpen={invoiceDetailsModal} toggle={invoiceDetailsModalToggle}>
                <ModalHeader toggle={invoiceDetailsModalToggle} close={
                    <button className="close" onClick={invoiceDetailsModalToggle}>
                        &times;
                    </button>
                }>Invoice details</ModalHeader>
                <ModalBody>
                    <div className="card-box">
                        <h4 className="header-title">{invoice.name}</h4>
                        <p className="sub-header">
                            <Avatar size={95} name={invoice.merchant_business_name} round/>
                        </p>
                        <div className="table-responsive">
                            <table className="table mb-0">
                                <tbody>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Invoice ID</td>
                                    <td>{invoice.id}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Invoice Number</td>
                                    <td>{invoice.invoice_number || '-'}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Invoice URL</td>
                                    <td>{renderCopyableLink(invoiceUrl, invoiceHref)}</td>
                                </tr>
                                {invoice.short_invoice_url && (
                                    <tr>
                                        <th scope="row"> </th>
                                        <td>Short Invoice URL</td>
                                        <td>{renderCopyableLink(shortInvoiceUrl, shortInvoiceHref)}</td>
                                    </tr>
                                )}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Customer Name</td>
                                    <td>{invoice.customer_name}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Customer Email</td>
                                    <td>{invoice.customer_email || '-'}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Order ID</td>
                                    <td>{invoice.order.id}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Order Number</td>
                                    <td>{invoice.order.order_number || '-'}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Line Items</td>
                                    <td>
                                        <div className="mb-2">
                                            <span className="badge badge-light-primary">{invoice.order.order_items.length} items</span>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: "8px" }}>
                                            {invoice.order.order_items.slice(0, 4).map((item, index) => (
                                                <div key={item.id || index} title={item.name} style={{ display: 'flex', alignItems: 'center', gap: "8px" }}>
                                                    <span style={{ minWidth: '24px' }}>{index + 1}.</span>
                                                    {item?.product_add_on_item?.product_image || item?.product_group_add_on_item?.product_group_image ? (
                                                        <img
                                                            src={
                                                                item?.product_add_on_item?.product_image ||
                                                                item?.product_group_add_on_item?.product_group_image
                                                            }
                                                            className="avatar-sm img-thumbnail rounded-circle"
                                                            alt={item.name}
                                                            style={{ width: '35px', height: '35px' }}
                                                        />
                                                    ) : (
                                                        <Avatar size={35} name={item.name} round />
                                                    )}
                                                    <span>{item.name}</span>
                                                </div>
                                            ))}
                                            {invoice.order.order_items.length > 4 && (
                                                <>
                                                    {expandedProducts
                                                        ? invoice.order.order_items.slice(4).map((item, index) => (
                                                            <div key={item.id || index} title={item.name} style={{ display: 'flex', alignItems: 'center', gap: "8px" }}>
                                                                <span style={{ minWidth: '24px' }}>{index + 5}.</span>
                                                                {item?.product_add_on_item?.product_image || item?.product_group_add_on_item?.product_group_image ? (
                                                                    <img
                                                                        src={
                                                                            item?.product_add_on_item?.product_image ||
                                                                            item?.product_group_add_on_item?.product_group_image
                                                                        }
                                                                        className="avatar-sm img-thumbnail rounded-circle"
                                                                        alt={item.name}
                                                                        style={{ width: '35px', height: '35px' }}
                                                                    />
                                                                ) : (
                                                                    <Avatar size={35} name={item.name} round />
                                                                )}
                                                                <span>{item.name}</span>
                                                            </div>
                                                        ))
                                                        : null}
                                                    <span onClick={toggleExpansion} style={{ cursor: 'pointer' }}>
                                                        <div
                                                            style={{
                                                                width: '35px',
                                                                height: '35px',
                                                                backgroundColor: 'grey',
                                                                borderRadius: '50%',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                color: 'white',
                                                                fontSize: '12px',
                                                            }}
                                                        >
                                                            {!expandedProducts ? `+${invoice.order.order_items.length - 4}` : "-"}
                                                        </div>
                                                    </span>
                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Status</td>
                                    <td>
                                    {/*    <Badge badge={*/}
                                    {/*    invoice.is_paid === true*/}
                                    {/*        ? "badge badge-light-success"*/}
                                    {/*        : "badge badge-light-danger"*/}
                                    {/*} status={invoice.is_paid === true? "Yes": "No"}/>*/}
                                    {/*    <Badge*/}
                                    {/*        badge={*/}
                                    {/*            invoice.status === "PAID"*/}
                                    {/*                ? "badge badge-light-success"*/}
                                    {/*                : invoice.status === "UNPAID"*/}
                                    {/*                    ? "badge badge-light-warning"*/}
                                    {/*                    : "badge badge-light-danger"*/}
                                    {/*        }*/}
                                    {/*        status={invoice.status}*/}
                                    {/*    />*/}
                                        <Badge
                                            badge={invoiceStatusBadgeMap[invoice.status] || "badge badge-light-secondary"}
                                            status={invoice.status}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Sub Total(before discount)</td>
                                    <td>INR {invoice.sub_total_before_discount}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Discount</td>
                                    <td>INR {invoice.discount}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Sub Total(after discount)</td>
                                    <td>INR {invoice.sub_total_after_discount}</td>
                                </tr>
                                {invoice.document_type === "TAX_INVOICE" && (
                                    <>
                                        <tr>
                                            <th scope="row"> </th>
                                            <td>Tax Percentage(effective)</td>
                                            <td>{invoice.effective_tax_percentage} %</td>
                                        </tr>
                                        <tr>
                                            <th scope="row"> </th>
                                            <td>CGST</td>
                                            <td>INR {invoice.cgst}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row"> </th>
                                            <td>SGST</td>
                                            <td>INR {invoice.sgst}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row"> </th>
                                            <td>IGST</td>
                                            <td>INR {invoice.igst}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row"> </th>
                                            <td>UTGST</td>
                                            <td>INR {invoice.utgst}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row"> </th>
                                            <td>Total Tax</td>
                                            <td>INR {invoice.total_tax}</td>
                                        </tr>
                                    </>
                                )}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Total Amount</td>
                                    <td>INR {invoice.total_amount}</td>
                                </tr>
                                {invoice.shipping_label && (
                                    <>
                                        <tr>
                                            <th scope="row"> </th>
                                            <td>Shipping Address</td>
                                            <td>
                                                <strong>{invoice.shipping_label}</strong>
                                            </td>
                                        </tr>

                                        <tr>
                                            <th scope="row"> </th>
                                            <td>Shipping Location</td>
                                            <td>
                                                {invoice.shipping_address_line1}
                                                {invoice.shipping_address_line2 && `, ${invoice.shipping_address_line2}`}
                                                {invoice.shipping_address_line3 && `, ${invoice.shipping_address_line3}`}
                                                <br />
                                                {invoice.shipping_city}
                                                {invoice.shipping_state && `, ${invoice.shipping_state}`}
                                                {invoice.shipping_pincode && ` - ${invoice.shipping_pincode}`}
                                            </td>
                                        </tr>

                                        {invoice.shipping_phone_number && (
                                            <tr>
                                                <th scope="row"> </th>
                                                <td>Shipping Phone</td>
                                                <td>{invoice.shipping_phone_number}</td>
                                            </tr>
                                        )}
                                    </>
                                )}

                                <tr>
                                    <th scope="row"> </th>
                                    <td>Created</td>
                                    <td>{new Date(invoice.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Updated</td>
                                    <td>{new Date(invoice.updated).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>

    );
}

export default Invoice;
